import React, { useCallback, useMemo } from 'react'
import { useApp } from '../../../context/AppProvider'
import { filterBlockByType, isEmpty } from '../../../services/common'
import { Parser } from '../../common'

const Case = ({ block = {} }) => {
    const { childrens, attributes: { id: attributesId, condition } = {} } = block
    const titleBlock = filterBlockByType(childrens, 'Titre')
    const { selectedCase, setSelectedCase, selectedValue } = useApp()

    const onClickSelectedCase = useCallback(
        (id) => {
            setSelectedCase((prev) => [...prev, id])
        },
        [setSelectedCase]
    )

    const renderButton = useCallback(
        () => (
            <div
                className="baseocom-btn-case"
                key={attributesId}
                onClick={() => onClickSelectedCase(attributesId)}
            >
                {titleBlock?.content}
            </div>
        ),
        [attributesId, onClickSelectedCase, titleBlock]
    )

    const getBlockIfConditionMatches = useCallback(() => {
        if (!condition) {
            return false
        }

        const affectTrue = selectedValue?.map((value) => value.affectTrue)
        return condition?.some((cond) => affectTrue.includes(cond.var))
    }, [condition, selectedValue])

    const renderContent = useMemo(() => {
        if (isEmpty(selectedValue)) {
            if (isEmpty(selectedCase) || !selectedCase.includes(attributesId)) {
                return renderButton()
            } else {
                return <Parser content_block={childrens} type="checked" attributes={attributesId} />
            }
        } else {
            const hasConditionblock = getBlockIfConditionMatches()
            if (!hasConditionblock) {
                if (isEmpty(selectedCase) || !selectedCase.includes(attributesId)) {
                    return renderButton()
                } else {
                    return (
                        <Parser
                            content_block={childrens}
                            type="checked"
                            attributes={attributesId}
                        />
                    )
                }
            } else {
                const removeTitle = childrens?.filter((child) => child.block !== 'Titre')
                return <Parser content_block={removeTitle} />
            }
        }
    }, [
        selectedValue,
        selectedCase,
        attributesId,
        renderButton,
        childrens,
        getBlockIfConditionMatches,
    ])

    return <div className="baseocom-case">{renderContent}</div>
}

export default Case
